export const TenantDocumentKind = {
    ADMIN_ID: 'ADMIN_ID',
    REGISTRATION_CERTIFICATE: 'REGISTRATION_CERTIFICATE',
    INSURANCE: 'INSURANCE',
    OTHER: 'OTHER',
};
export const TenantDocumentStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
/**
 * What a firm must have approved before it is let in.
 *
 * `OTHER` is deliberately absent: it is the slot for whatever a category
 * happens to need — an ANRE authorisation for gas work, an ISCIR one for lifts
 * — and demanding it of every firm would block the ones that need none.
 *
 * A person checks these. No identity provider verifies an insurance
 * certificate; that the firm exists and trades is the registry check's job, and
 * who owns the bank account is the payment provider's.
 */
export const REQUIRED_TENANT_DOCUMENTS = [
    TenantDocumentKind.REGISTRATION_CERTIFICATE,
    TenantDocumentKind.INSURANCE,
];
export const WarrantyClaimStatus = {
    OPEN: 'OPEN',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    RESOLVED: 'RESOLVED',
};
export const NotificationChannel = {
    PUSH: 'PUSH',
    SMS: 'SMS',
    EMAIL: 'EMAIL',
};
export const DisputeStatus = {
    OPEN: 'OPEN',
    /** The client was right; the job is cancelled and the money returned. */
    UPHELD: 'UPHELD',
    /** The charge stands, with a reason the client is told. */
    REJECTED: 'REJECTED',
};
export const AuditFlagKind = {
    /** Three consecutive jobs completed in under five minutes. */
    RAPID_COMPLETION: 'RAPID_COMPLETION',
    LOW_RATING_STREAK: 'LOW_RATING_STREAK',
    EXCESSIVE_CANCELLATION: 'EXCESSIVE_CANCELLATION',
    MANUAL: 'MANUAL',
};
export const AuditFlagStatus = {
    OPEN: 'OPEN',
    REVIEWING: 'REVIEWING',
    CLEARED: 'CLEARED',
    ACTIONED: 'ACTIONED',
};
export const OneTimeLinkPurpose = {
    WORKER_INVITE: 'WORKER_INVITE',
    /** Sent to an approved firm's contact address; it claims the admin account. */
    TENANT_ADMIN_INVITE: 'TENANT_ADMIN_INVITE',
    /** Sent by a corporate client to a colleague joining the same organisation. */
    ORGANISATION_INVITE: 'ORGANISATION_INVITE',
    PASSWORD_RESET: 'PASSWORD_RESET',
    EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
    PHONE_VERIFICATION: 'PHONE_VERIFICATION',
};
/**
 * Jobs a firm must complete before probation ends (README section 1). While on
 * probation a firm has lower dispatch priority unless it is the closest or the
 * only option.
 */
export const PROBATION_JOB_THRESHOLD = 15;
/**
 * The longest warranty a firm may promise, in days.
 *
 * Not a legal limit — Romanian consumer law is its own question — but a guard
 * against a typo: a firm meaning 30 and typing 3000 would be held to eight
 * years by its own dashboard.
 */
export const MAX_WARRANTY_DAYS = 730;
/** Consecutive suspiciously fast completions that trip an audit flag. */
export const RAPID_COMPLETION_STREAK = 3;
export const RAPID_COMPLETION_THRESHOLD_MINUTES = 5;
//# sourceMappingURL=operations.js.map